import { Record } from '@phosphor-icons/react';

export default Record;
